import { Editor } from "@tiptap/react";
import { EditorState } from "@tiptap/pm/state";
import { EditorView } from "@tiptap/pm/view";
import { TableMap } from "@tiptap/pm/tables";

import { findTable, isTableSelected } from "../../utils";
import { Table } from "../..";

export const isRowGripSelected = ({
  editor,
  view,
  state,
  from,
}: {
  editor: Editor;
  view: EditorView;
  state: EditorState;
  from: number;
}) => {
  const domAtPos = view.domAtPos(from).node as HTMLElement;
  const nodeDOM = view.nodeDOM(from) as HTMLElement;
  const node = nodeDOM || domAtPos;

  // isTableSelected normally means "an ambiguous whole-table selection, not a specific
  // row" — but selecting a row always spans every column, so on a table with only one row,
  // selecting it IS selecting the whole table. That bail-out would hide this menu on every
  // 1-row table (DMS-2004 item 3).
  const table = findTable(state.selection);
  const isAmbiguousTableSelection = table ? TableMap.get(table.node).height > 1 : false;

  if (
    !editor.isActive(Table.name) ||
    !node ||
    (isAmbiguousTableSelection && isTableSelected(state.selection))
  ) {
    return false;
  }

  let container = node;

  while (container && !["TD", "TH"].includes(container.tagName)) {
    container = container.parentElement!;
  }

  const gripRow = container && container.querySelector && container.querySelector("a.grip-row.selected");

  return !!gripRow;
};

export default isRowGripSelected;
